<template>
  <div class="metricas-recomendacoes metricas-recomendacoes-container">
    <RecommendationResultsDashboard />
  </div>
</template>

<script>
import RecommendationResultsDashboard from './recommendations-dashboard/RecommendationResultsDashboard.vue'

export default {
  name: 'MetricasRecomendacoes',
  components: {
    RecommendationResultsDashboard,
  },
}
</script>
